import styled from 'styled-components';

export const InputWrapper = styled.div`
    margin: 0 auto ${({ theme }) => theme.spacing * 10}px;
    width: 940px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: ${({ theme }) => theme.spacing * 5}px;
    @media screen and (max-width: 690px) {
        width: 100%;
        padding: 0 12px;
        box-sizing: border-box;
        grid-template-columns: 100%;
        grid-row-gap: ${({ theme }) => theme.spacing * 5}px;
    }
`;

export const InfoRow = styled.div`
    width: 940px;
    height: 44px;
    margin: 0 auto;
    padding: 0 ${({ theme }) => theme.spacing * 6}px;;
    box-sizing: border-box;
    display: grid;
    align-items: center;
    grid-column-gap: ${({ theme }) => theme.spacing * 4}px;
    grid-template-columns: 50px 156px auto 90px 60px 30px;
    > p {
        margin: 0;
        font-size: 12px;
        font-weight: bold;
        color: ${({ theme }) => theme.colors.darkBlueAlphaMedium};
        opacity: .87;
    }
`;
